<template>
    <base-template :hidehelp="true">
        <header class="header header-home header-partners">
            <div class="grid-container">
                <div class="grid-x grid-padding-x">
                    <div class="cell">
                        <div class="header-home__content">
                            <img
                                class="header-home__logo"
                                src="@/assets/img/logos/ijstijd.svg"
                                alt="ijstijd">

                            <h1>Verzilver je unieke IJSTIJD! code</h1>

                            <div class="header__intro">
                                Krijg gratis toegang tot een ijsbaan inclusief schaatshuur.<br>
                                Je kunt alleen schaatsen bij de aangesloten tijdelijke schaatsbanen van IJSTIJD!
                            </div>
                        </div>

                        <div class="filter-bar">
                            <img
                                class="filter-bar__figure"
                                src="@/assets/img/content/guy_full.png" >

                            <h2 class="h5 filter-bar__title">Waar wil je schaatsen?</h2>

                            <form class="filter-bar__form">
                                <div class="grid-y grid-padding-y medium-auto">
                                    <div class="cell">
                                        <div class="grid-x grid-padding-x grid-padding-y small-up-1 large-up-2">
                                            <div class="cell">
                                                <vselect-field
                                                    :options="options"
                                                    placeholder="Kies ijsbaan"
                                                    v-model="datamodel.product">
                                                    <template v-slot:label>
                                                        IJsbaan <span class="sublabel"> - bekijk
                                                        <a @click.prevent="openModal">
                                                            <b>hier</b>
                                                        </a>
                                                        de deelnemende ijsbanen <img src="@/assets/icons/location-map-pin.svg" @click.prevent="openModal" alt="Toon kaart" title="Toon kaart">
                                                    </span>
                                                    </template>
                                                </vselect-field>
                                            </div>

                                            <div class="cell">
                                                <input-field
                                                    name="code"
                                                    label="Unieke IJSTIJD! code"
                                                    :errors="errors"
                                                    v-model="datamodel.code"
                                                    v-validate="'required'"
                                                    placeholder="#"/>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="cell">
                                        <div class="grid-x grid-padding-x grid-padding-y small-up-1 large-up-3">
                                            <div class="cell">
                                                <input-field
                                                    :errors="errors"
                                                    v-model="datamodel.user.first_name"
                                                    placeholder="Voornaam"
                                                    name="user.first_name"
                                                    v-validate="'required'"
                                                    :required="true"/>
                                            </div>
                                            <div class="cell">
                                                <input-field
                                                    :errors="errors"
                                                    v-validate="'required'"
                                                    placeholder="Achternaam"
                                                    v-model="datamodel.user.last_name"
                                                    name="user.last_name"
                                                    :required="true"/>
                                            </div>
                                            <div class="cell">
                                                <input-field
                                                    :errors="errors"
                                                    v-validate="'required'"
                                                    placeholder="E-mailadres"
                                                    v-model="datamodel.user.email"
                                                    name="user.email"
                                                    :required="true"/>
                                            </div>
                                        </div>
                                        <div class="cell">
                                            <div class="grid-y grid-padding-y">
                                                <div class="cell">
                                                    <checkbox-field
                                                        :errors="errors"
                                                        v-model="datamodel.newsletter"
                                                        v-validate="'required:true'"
                                                        name="newsletter">
                                                        Ja, ik wil op de hoogte gehouden worden van nieuws, acties een aanbiedingen van schaatsen.nl
                                                    </checkbox-field>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="formfield__servererror" v-if="error">{{error}}</div>

                                    <div class="cell medium-shrink">
                                        <button
                                            :disabled="form_disabled"
                                            class="btn btn--white"
                                            @click.prevent="redeem()">
                                            Verzilveren
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>

                    </div>
                </div>
            </div>
        </header>
        <template v-slot:faq>
            <nav>
                <ul>
                    <li>
                        Heb je vragen of hulp nodig?  <a href="mailto:ijstijd@knsb.nl">ijstijd@knsb.nl</a>
                    </li>
                </ul>
            </nav>
        </template>

        <sport-modal :show-modal="showModal" @close="closeModal">
            <location-map :locations="options" @chosen="chosen"></location-map>
        </sport-modal>

        <sport-modal class="popup-unavailable" :show-modal="show_unavailable_modal" @close="closeModal">
            <h2>Reserveer via de website</h2>
            <p>
                Voor Schaatsbaan Rotterdam dien je rechtstreeks een ticket en tijdslot te reserveren via
                <a href="https://tickets.schaatsbaanrotterdam.nl/nl-NL/tickets?journey=tickets">Schaatsbaan Rotterdam - Seizoen 2021/2022</a>.
                Gebruik hierbij de ontvangen actiecode voor gratis toegang en huur van schaatsen
            </p>
            <template v-slot:buttons>
                <a href="https://tickets.schaatsbaanrotterdam.nl/nl-NL/tickets?journey=tickets" class="btn">Reserveren</a>
            </template>
        </sport-modal>
    </base-template>
</template>

<style>
    label .sublabel {
        font-weight: normal;
    }

    label img {
        vertical-align: baseline;
    }

    label a:hover {
        color: initial;
    }

    .popup-unavailable .modal {
        width: 500px;
        height: 500px;
        padding: 2em;
    }
</style>

<script>
import BaseTemplate from '@/components/base/BaseTemplate.vue';
import { mapActions } from 'vuex';
import { TweenLite } from 'gsap';
import LocationMap from "../components/LocationMap";

export default {
    inject: ['$validator'],

    data() {
        return {
            loading: false,
            ordered: false,

            error: undefined,

            showModal: false,
            datamodel: {
                code: '',
                type: null,
                product: null,
                newsletter: false,
                user: {
                    first_name: '',
                    last_name: '',
                    email: ''
                }
            },
            form_disabled: false,
            show_unavailable_modal: false,
        };
    },
    components: {
        LocationMap,
        BaseTemplate,
    },
    watch: {
        $route: 'load',
        currentProduct: function(newVal) {
            if (newVal.id === 300) {
                this.show_unavailable_modal = true;
                this.form_disabled = true;
            } else {
                this.show_unavailable_modal = false;
                this.form_disabled = false;
            }
        }
    },
    mounted() {
        this.load();
    },

    computed: {
        options () {
            return (this.$store.state.products.items || []).map((item) => {
                return {
                    label: `${item.location.name} - ${item.location.city} ${this.isFull(item) ? ' (uitverkocht)' : ''}`,
                    id: item.id,
                    type: item.type,
                    coordinates: item.coordinates,
                    lat: item.latitude,
                    lng: item.longitude,
                    thumbnail: item.location?.images?.thumbnail
                }
            })
        },
        currentProduct() {
            if (!this.datamodel.product) {
                return {};
            }

            return this.$store.state.products.items.find(item => parseInt(item.id, 10) === parseInt(this.datamodel.product.id, 10)) || {}
        }
    },
    methods: {
        ...mapActions({
            'getProducts': 'products/getProducts',
            'order': 'products/partnerOrder'
        }),

        load() {
            this.getProducts({partner: true});
        },

        openModal() {
            this.showModal = true;
        },

        closeModal() {
            this.showModal = false;
            this.show_unavailable_modal = false;
        },
        destroy() {
            TweenLite.killTweensOf('body, html');
        },

        isFull(product) {
            return product.capacity <= product.order_count;
        },

        chosen(point) {
            this.datamodel.product = point;
            this.closeModal();
        },

        redeem() {
            const data = {
                code: this.datamodel.code,
                id: this.currentProduct.id,
                type: this.currentProduct.type,
                user: this.datamodel.user,
                newsletter: this.datamodel.newsletter
            };

            this.order(data, this.datamodel.code).then(() => {
                this.$router.push({name: 'partner.thanks'});
            }).catch(({data}) => {
                // check if errors exist
                if(!data.hasOwnProperty('errors')) {
                    return;
                }

                let errorFields = Object.keys(data.errors);

                // insert laravel errors
                errorFields.map(field => {
                    let errorString = data.errors[field].join(', ');
                    this.$validator.errors.add({
                        field: field,
                        msg: errorString
                    });
                });

            });
        },
    },
};
</script>
